import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Tab icons ported verbatim from TMS (kaneai ProjectsDetailsNavIcons.tsx:
 * report-portal / test-instances / issues entities) so the evidence tab bar
 * is pixel-identical to the native test-run page. Decorative — the tab
 * labels carry the text.
 */

export function ReportTabIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.4 15H2.6C2.44087 15 2 15 2 15C2 15 2 14.5714 2 14.4167V1.58333C2 1.42862 2 1 2 1C2 1 2.44087 1 2.6 1H10.197C10.3272 1 10.4522 1.05076 10.5455 1.1415L14 4.5V14.4167C14 14.5714 14 15 14 15C14 15 13.5591 15 13.4 15Z",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.125 2C10.125 1.65482 9.84518 1.375 9.5 1.375C9.15482 1.375 8.875 1.65482 8.875 2H10.125ZM9.5 5.5H8.875C8.875 5.84518 9.15482 6.125 9.5 6.125V5.5ZM13 6.125H13.625V4.875H13V6.125ZM9.5 2H8.875V5.5H9.5H10.125V2H9.5ZM9.5 5.5V6.125H13V5.5V4.875H9.5V5.5Z",
      fill: "#6E7781"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 9H11",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 12H11",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
}
export function InstancesTabIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.33203 4.66797V9.33464",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8 4.66797V7.33464",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.666 4.66797V10.668",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
}
export function IssuesTabIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.3044 8.75H11.153",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.85144 8.75H1.7",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.1531 7.17434V10.3252C11.1531 10.5038 11.1378 10.6823 11.106 10.8504C10.859 12.3421 9.56233 13.4761 8.00221 13.4761C6.44209 13.4761 5.14537 12.3421 4.8984 10.8504C4.86719 10.6823 4.85131 10.5038 4.85131 10.3252V7.17434C4.85131 6.99582 4.86719 6.8173 4.8984 6.64919C5.14537 5.15752 6.44209 4.02344 8.00221 4.02344C8.87399 4.02344 9.66144 4.375 10.2293 4.94779C10.6855 5.39901 11.0014 5.98768 11.106 6.64919C11.1378 6.8173 11.1531 6.99582 11.1531 7.17434Z",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.2253 3.49609V3.94075C2.2253 4.64441 2.50129 5.32015 2.99358 5.82285L3.01001 5.83983C3.51545 6.35622 4.20816 6.64699 4.931 6.64699H11.0893C11.8028 6.64699 12.4868 6.36388 12.9917 5.85899C13.496 5.3552 13.7797 4.6707 13.7797 3.95772V3.49609",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.1059 10.8477H11.1207C11.814 10.8477 12.4787 11.1226 12.9689 11.6127L13.0132 11.6576C13.5039 12.1477 13.7793 12.8125 13.7793 13.5057V13.9986",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.22548 13.9986V13.5221C2.22548 12.8376 2.4938 12.1811 2.97241 11.6926L3.03319 11.6313C3.52439 11.1302 4.19684 10.8477 4.89887 10.8477",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.00239 6.64844V13.4754",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10.1026 4.82852V3.49456C10.1026 2.81571 9.67329 2.23718 9.07136 2.01562",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5.90155 4.83083V3.49687C5.90155 2.79882 6.35547 2.20685 6.98426 2",
      stroke: "#6E7781",
      strokeWidth: 1.25,
      strokeLinecap: "round"
    })]
  });
}

/** Shield-check Coverage tab icon — exact Figma glyph (30739-126300). */
export var CoverageTabIcon = function CoverageTabIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6 8L7.33333 9.33333L10 6.66667M13.3333 8.66666C13.3333 12 11 13.6667 8.22667 14.6333C8.08144 14.6825 7.92369 14.6802 7.78 14.6267C5 13.6667 2.66667 12 2.66667 8.66666V3.99999C2.66667 3.82318 2.7369 3.65361 2.86193 3.52859C2.98695 3.40357 3.15652 3.33333 3.33333 3.33333C4.66667 3.33333 6.33333 2.53333 7.49333 1.51999C7.63457 1.39933 7.81424 1.33303 8 1.33303C8.18576 1.33303 8.36543 1.39933 8.50667 1.51999C9.67333 2.53999 11.3333 3.33333 12.6667 3.33333C12.8435 3.33333 13.013 3.40357 13.1381 3.52859C13.2631 3.65361 13.3333 3.82318 13.3333 3.99999V8.66666Z",
      stroke: "currentColor",
      strokeWidth: "1.25",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};